
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post-policy",
      function () {
        return require("private-next-pages/post-policy/index.tsx");
      }
    ]);
  